import AddProductsEvents from './AddProductsEvents';
import ArtEvents from './ArtEvents';
import LabEvents from './LabEvents';
import NamesNumbersEvents from './NamesNumbersEvents';
import NotesEvents from './NotesEvents';
import PageViewEvents from './PageViewEvents';
import ProductEvents from './ProductEvents';
import TextEvents from './TextEvents';
import UploadEvents from './UploadEvents';
import {getAnalyticsEventsDictionary} from './utils';

export const analyticsEvents = getAnalyticsEventsDictionary([
  AddProductsEvents,
  ArtEvents,
  LabEvents,
  NamesNumbersEvents,
  NotesEvents,
  PageViewEvents,
  ProductEvents,
  TextEvents,
  UploadEvents
]);

export const getTrackerEvents = (state, action) => {
  return analyticsEvents?.[action.type]?.map(event => {
    return event?.(state, action);
  });
};
